'use client';

import React, { FC } from 'react';
import Link from '~/data/strapi/types/shared-components/link';

import DropdownLink from './dropdown-link';
import DropdownSubLink from './dropdown-sublink';
import styles from './styles.module.css';

interface Props {
  links: Link[];
}

const Nav: FC<Props> = ({ links }) => {
  return (
    <nav className={styles.nav}>
      {links.map((link) => {
        const sublinks = link.links || [];
        const parentHref = link.href;

        return (
          <DropdownLink link={link} key={link.id}>
            {sublinks.map((sublink, index) =>
              sublink.href && sublink.title ? (
                <DropdownSubLink parentHref={parentHref} link={sublink} key={sublink.title + index} />
              ) : null
            )}
          </DropdownLink>
        );
      })}
    </nav>
  );
};

export default Nav;
